var _style, _circle, _g, _g2, _g3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#FFDA44;}\n\t.st4{fill:#D80027;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.9,133.6c-33.1-60.6-90-106.4-158.1-124.8l-11.1,124.8H480.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,133.6h169.2L189.2,8.8C121.1,27.2,64.2,72.9,31.1,133.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.7,256v122.4h169.2C500.7,342.1,512,300.4,512,256H311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,256H0c0,44.4,11.3,86.1,31.1,122.4h169.2L200.3,256L200.3,256z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,378.4c33.1,60.6,90,106.4,158.1,124.8l11.1-109.1L31.1,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.8,503.2c68.1-18.4,125-64.1,158.1-124.8l-169.2,15.6L322.8,503.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.7,394.1l169.2-15.6H311.7L311.7,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.3,378.4H31.1l169.2,15.6V378.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256,0c-23.1,0-45.5,3.1-66.8,8.8v494.4c21.3,5.7,43.7,8.8,66.8,8.8s45.5-3.1,66.8-8.8V8.8 C301.5,3.1,279.1,0,256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.7,55.7l6.9,21.3H167L148.9,90l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.4L137.7,55.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.04a953f43107471ba00c8278cca04e4a.svg";
export { ForwardRef as ReactComponent };